import replace from 'lodash/replace'
export default {
  filters: {
    $_dataFilter_guidance(value) {
      return replace(value, new RegExp('_', 'g'), ' ')
      // return value.replace('_', ' ')
    }
  }
}
